import { render } from "./OrganizationProjectSelector.vue?vue&type=template&id=08ecbc0a&lang=pug"
import script from "./OrganizationProjectSelector.vue?vue&type=script&lang=js"
export * from "./OrganizationProjectSelector.vue?vue&type=script&lang=js"

import "./OrganizationProjectSelector.vue?vue&type=style&index=0&id=08ecbc0a&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__